import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/app/current/node_modules/next/dist/client/app-dir/link.js");
